import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadTenant = useCallback(async () => {
    try {
      const { data } = await api.get("/tenant/current");
      setTenant(data);
      if (data?.brand_color) {
        document.documentElement.style.setProperty("--brand-accent", data.brand_color);
      }
    } catch (e) { /* ignore */ }
  }, []);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      await loadTenant();
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, [loadTenant]);

  useEffect(() => {
    // If returning from Emergent OAuth, skip /me check; AuthCallback handles it
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("sp_token", data.token);
    setUser(data.user);
    await loadTenant();
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("sp_token", data.token);
    setUser(data.user);
    await loadTenant();
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("sp_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, tenant, loading, refresh, login, register, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
